"use client";
import { useCallback, useMemo, useState } from "react";
import Modal from "../../theme/components/Modal";
import { FormField } from "../../theme/components/Form";
import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const useLocaleSwitcherModal = () => {
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const locale = useLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const t = useTranslations();
  const openLocaleSwitcher = useCallback(() => setShowLanguageModal(true), []);
  const closeLocaleSwitcher = useCallback(
    () => setShowLanguageModal(false),
    [],
  );

  const supportedLocales = {
    locale_de: t("footer_language_selector_german"),
    locale_fr: t("footer_language_selector_french"),
    locale_it: t("footer_language_selector_italian"),
  };

  const switchLocale = useCallback(
    (e) => {
      e.stopPropagation();
      router.push(
        `${pathname.toString().replace(`/${locale}`, `/${e.target.value.split("_")[1]}`)}?${searchParams.toString()}`,
      );
    },
    [locale],
  );

  const LocaleSwitcherModal = useMemo(
    () => (
      <Modal
        open={showLanguageModal}
        onClose={closeLocaleSwitcher}
        title={t("language")}
      >
        <fieldset>
          <FormField
            onChange={switchLocale}
            type="radio"
            name="locale"
            options={Object.entries(supportedLocales).map(([key, value]) => ({
              label: value,
              value: key,
            }))}
            defaultValue={`locale_${locale}`}
          />
        </fieldset>
      </Modal>
    ),
    [
      locale,
      showLanguageModal,
      closeLocaleSwitcher,
      supportedLocales,
      switchLocale,
    ],
  );

  return {
    openLocaleSwitcher,
    LocaleSwitcherModal,
    supportedLocales,
  };
};

export default useLocaleSwitcherModal;
